export default __webpack_public_path__ + "static/media/close.fe60b5c9.svg";